<div
  #scrollContainer
  sondermindMediaQueryAttribute
  class="flows-host-backdrop"
  [ngClass]="{'position-fixed': isFullHeight}"
  [@fade]="wizard.running$ | async"
  (@fade.done)="fadeComplete()"
>
  <div class="flow-spinner" *ngIf="wizard.started !== true">
    <div class="flow-spinner-container">
      <mat-spinner
        color="primary"
        diameter="88"
        strokeWidth="6"
        aria-label="Loading Match Flow"
      ></mat-spinner>
    </div>
  </div>
  <div #flowContainer>
    <div
      *ngIf="data$ | async as data"
      class="flows-host-container mat-typography"
      [ngClass]="{'full-height': isFullHeight}"
      sonderMediaqueryClass="mq"
    >
      <flows-intake-header
        [@fadeHeader]="wizard.running$ | async"
        sondermindResizeObserver
        (backClicked)="handleBack()"
        [back]="wizard.canBack()"
        [component]="data.component"
        [isLogoClickable]="isLogoClickable"
      ></flows-intake-header>
      <flows-intake-host-progress-bar
        *ngIf="hasProgressValue"
        sondermindMediaQueryAttribute
        class="progress-bar"
        [progressBarValue]="progress"
      >
      </flows-intake-host-progress-bar>

      <div class="flows-animation-container"
        [@changeStep]="{
          value: flowDirection,
          params: {animationDuration: '500ms'}
        }"
        (@changeStep.done)="flowDirection = null"
      >
        <ng-container *ngFor="let component of data.config.steps">
          <div
            *ngIf="component.slug === data.step"
            class="flost-host-child-container"
          >
            <div
              id="flows-host-child"
              class="flows-host-child flows-host-wizard"
            >
              <flows-intake-step-host
                [ngClass]="{ 'flows-intake-step-host': (showCallComponent$ | async)}"
                [component]="component"
                [response]="data.response"
                [resetable]="wizard.resetable"
                (stepNext)="nextButtonClickedInFlow($event)"
                (stepBack)="backButtonClickedInFlow()"
                (stepExit)="wizard.exit()"
                (stepReset)="wizard.reset()"
                cdkTrapFocus
                [busy]="busy"
                [hideStepNoticeText]="(showCallComponent$ | async) && component.slug === 'reason'"
                data-test="pause-page-text"
              ></flows-intake-step-host>

              <div
                *ngIf="(showCallComponent$ | async) && callComponentSlugs.includes(component.slug)"
                class="were-here-to-help"
              >
                <div class="display-text">
                  <h3>We're here to help</h3>
                  <p>Give us a call and one of our Care Coordinators will help you find a therapist over the phone.</p>
                </div>

                <div class="call-button">
                    <iris-button
                      type="secondary"
                    >
                      <div class="iris-button-content">
                        <mat-icon>phone</mat-icon>
                        <a class="call-button-link" href="tel:8669418770">
                          Call (866) 941-8770
                        </a> 
                      </div>
                    </iris-button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <flows-intake-footer
        *ngIf="isFooterVisible && !!data.component.config.footer"
        id="flows-intake-footer"
        sondermindMediaQueryAttribute
        [footer]="data.component.config.footer"
      ></flows-intake-footer>
    </div>
  </div>
</div>
